// extracted by mini-css-extract-plugin
module.exports = {"cardBadgeImg":"_0ec0536"};